import { ISymbolConfig, ISymbolDim } from "./config/IReelSymbolStruct";
import { SymbolData } from "./config/SymbolData";
import { ReelBaseSymbol } from "./ReelBaseSymbol";
import { StateHandler } from "../../utils/StateHandler";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class ReelSymbolStates extends StateHandler {
    public static readonly NORMAL:string = "normal";
    public static readonly SPIN:string =   "spin";
    public static readonly WIN:string =    "win";
    public static readonly ATTENTION:string = "attention";
    public static readonly STICKY:string = "sticky";
    public static readonly IDLE:string =   "idle";
    public static readonly ACTIVE:string = "active";
    public static readonly INACTIVE:string = "inactive";
}

export abstract class ReelSpriteSymbolArea extends ReelBaseSymbol {
 
    public get mainSp():PIXI.Sprite{
        return this._mainSp;
    }

    public get subSp():PIXI.Sprite{
        return this._subSp;
    }

    public get dim():ISymbolDim | undefined{
        return SymbolData.getDimFromConfig(this.symbolConfig, this.state.value, this.sizeType.value);
    }

    public get symbolHeight():number{
        return this.dim ? this.dim.HEIGHT + this.dim.PADDING_Y  : SymbolData.DEFAULT_DIM.HEIGHT + SymbolData.DEFAULT_DIM.PADDING_Y;
    }

    public get symbolWidht():number{
        return this.dim ? this.dim.WIDTH  + this.dim.PADDING_X : SymbolData.DEFAULT_DIM.WIDTH + SymbolData.DEFAULT_DIM.PADDING_Y;
    }

    public get symbolSizeY():number{
        return (this.symbolHeight * this.scale.y);
    }

    public get symbolSizeX():number{
        return (this.symbolWidht * this.scale.x);
    }

    constructor(ID:number, symName:string, state:string = ReelSymbolStates.NORMAL, type:any){
        super(ID,state,type);
        this.Init();
        this.setSymbol(symName);
    }  

    protected Init():void{
        this.sortableChildren = true;

        this._mainSp = this.addChild(new PIXI.Sprite());
        this._mainSp.anchor.set(0.5,0.5);

        this._subSp = this.addChild(new PIXI.Sprite());
        this._subSp.anchor.set(0.5,0.5);
        
        this.createGraphics();
        this.sortChildren();
    }

    protected createGraphics(): void {
        this._darkSquareGfx = new PIXI.Graphics();
        this._darkSquareGfx.alpha = 0;

        this.addChild(this._darkSquareGfx);

        this._darkSquareGfx.zIndex = 300;
        this.sortChildren();
    }

    protected updateGraphics():void{
        if(!this._darkSquareGfx.parent) return;

        const w: number = this.symbolSizeX;
        const h: number = this.symbolSizeY;

        this._darkSquareGfx.clear();
        this._darkSquareGfx.beginFill(0x000000, 1);
        this._darkSquareGfx.drawRect(-w * 0.5, -h * 0.5, w, h);
        this._darkSquareGfx.endFill();
    }

    public setSymbol(symName:string):void{

        let newConfig:ISymbolConfig | undefined =  SymbolData.getConfig(symName);

        if(!newConfig || newConfig.NAME == "") { Logger.warn("Couldn't find symbol: " + symName); return; }
        
        this.symbolConfig = newConfig;
        this.scale = this.dim ? this.dim.SCALE : new PIXI.Point(1,1);

        const TEXTURES:PIXI.Texture[] | undefined = SymbolData.getTextures(this.symbolConfig.NAME, this.state.value, this.sizeType.value);

        if(TEXTURES){
            this._subSp.texture = this.mainSp.texture;
            this._subSp.alpha = 0;

            this.mainSp.texture = TEXTURES[0];
            this.mainSp.alpha = 1;
            this.mainSp.visible = true;
            this.mainSp.updateTransform();
        }

        this.setPosID(this.posID[0]);
        this.updateGraphics();
    }

    public remove():void{
        this.destroy({children:true});
    }
}
